<!-- 账号绑定 -->
<template>
  <div class='account-binding account-page'>
    <img src="@/assets/imgs/other/accoun-bind.png" alt="" class="banner">
    <div class="pad-side20" v-if="!autoPhone">
      <p class="font12">手机号码</p>
      <input name="手机号" type="tel" placeholder="请输入手机号" maxlength="11" v-model="reqData.phoneNo" @blur="phoneBlur">
      <p class="font12">验证码</p>
      <div class="relative-wrap">
        <input name="验证码" type="text" placeholder="请输入手机验证码" maxlength="6" v-model="reqData.code">
        <GetVerificationCode @sendCode="sendCode" class="getcode-btn" :reqData='{phoneNo: reqData.phoneNo, type: "11"}' />
      </div>
      <div class="protol flex align-items-center" @click.stop="agree=!agree">
        <img src="@/assets/imgs/icon/checked.png" alt="" v-show="agree">
        <img src="@/assets/imgs/icon/check.png" alt="" v-show="!agree">
        <p class="font10">阅读并同意<span @click.stop="readProtol(9)">隐私政策</span></p>
      </div>
    </div>
    <div class="btn-wrap flex justify-content-center">
      <input type="button" value="确定" class="lg-btn" @click="bindAccount">
    </div>
    <!-- <van-popup v-model="showProtol" class="my-dialog protol-wrap">
      <h3 class="title margin-b10">{{protol.copySubject}}</h3>
      <div v-html="protol.copyContent"></div>
      <input type="button" value="同意" class="hollow-btn" @click="agreeProtol">
    </van-popup> -->
    <van-popup v-model="showBindSucces" class="my-dialog">
      <img src="@/assets/imgs/other/good.png" alt="">
      <h3 class="title margin-b10">绑定成功！</h3>
      <div>您的账号已与微信号成功绑定</div>
      <input type="button" value="好的" class="hollow-btn hollow-btn2" @click="good">
    </van-popup>
    <van-popup v-model="showRegisterDialog" class="register-dialog">
      <div class="content">该手机号还未注册，赶紧去注册吧</div>
      <div class="flex justify-content-between register-btn">
        <input type="button" value="取消" class="mid-btn" @click="refuse">
        <input type="button" value="注册" class="hollow-btn" @click="navigatePageTo">
      </div>
    </van-popup>
  </div>
</template>

<script>
import GetVerificationCode from "@/components/GetVerificationCode.vue";
import { reqBindWeChat, reqProtol, reqWxTest, reqWxToken, reqWxUserInfo } from "@/api";
import { checkPhone } from "@/utils/verifyFunc";
import JVerify from '@/utils/jverify'

export default {
  name: 'AccountBinding',

  components: {
    GetVerificationCode,
  },

  data () {
    return {
      agree: false,
      showProtol: false,
      showBindSucces: false,
      protol: {},
      reqData: {
        code: '',
        phoneNo: '',
        wxuuid: ''
      },
      showRegisterDialog: false,
      hasCode: false,
      // 是否为一键登录
      autoPhone: false,
      operater: '',
      // 一键登录获取到的token
      verifyToken: '',
    };
  },
  activated() {
    let isAgree = localStorage.getItem('agreeProtol')
    // if(isAgree) {
    //   this.agree = true
    // }
  },
  created() {
    if (this.getUrlCode().code) {
      this.getOpenid()
    }
    let num = 0;
    let intv = setInterval(() => {
      if (num++ === 10) {
        clearInterval(intv);
        return;
      }
      if (JVerify.isInitial()) {
        clearInterval(intv);
        // 设置一键登录UI样式
        JVerify.setLoginUI();
        this.doLoginAuth();
      }
    }, 500);
  },
  methods: {
    // 进行一键登录鉴权
    doLoginAuth() {
      JVerify.loginAuth('AccountBinding')
      .then((data) => {
        let {
          content: token,
          operater
        } = data;
        this.operater = operater;
        // 获取到Token，根据Token请求加密手机号
        // this.getEncryptMobile(token);
        if (token && token !== '') {
          this.autoPhone = true;
          this.verifyToken = token;
          this.bindAccount();
        }
      }).catch((err) => {
        console.error(err);
      });
    },

    sendCode() {
      this.hasCode = true
    },
    phoneBlur(e) {
      if (!this.reqData.phoneNo) {
        this.$toast("请输入手机号")
        return
      }
      if (this.reqData.phoneNo && !checkPhone(this.reqData.phoneNo)) {
        this.$toast("请输入正确的手机号")
        return false
      }
      // if (e) {
      //   reqSystemInfo({
      //     queryType: 1,
      //     phoneNo: this.reqData.phoneNo
      //   }).then(res => {
      //     return true
      //   }).catch(err => {
      //     this.showRegisterDialog = true
      //     // if (err.data.resCode === '0005') {
      //     //   this.$toast("您还未注册，赶紧去注册吧")
      //     // }
      //   })
      // }
      return true
    },
    bindAccount() {
      let openid = localStorage.openid
      if (openid) {
        if (this.autoPhone) {
          reqBindWeChat({
            deviceOS: 'H5',
            loginToken: this.verifyToken,
            wxuuid: openid
          }).then(res => {
            this.showBindSucces = true;
          }).catch(err => {
            console.log(err)
            if (err.data.resCode === '0001') {
              this.showRegisterDialog = true;
            }
          })
          return;
        }
        this.reqData.wxuuid = openid
        let { code, phoneNo } = this.reqData;
        if(!phoneNo) {
          this.$toast("请输入手机号")
          return;
        }
        if(!checkPhone(phoneNo)) {
          this.$toast("请输入正确的手机号")
          return;
        }
        if (!this.hasCode) {
          this.$toast("您未获取验证码")
          return;
        }
        if(!code) {
          this.$toast("请输入验证码")
          return;
        }
        if(code.length<6) {
          this.$toast("请输入6位的验证码")
          return;
        }
        if(!this.agree) {
          this.$toast("请阅读并同意‘隐私政策’")
          return;
        }
        reqBindWeChat(this.reqData).then(res => {
          this.showBindSucces = true;
        }).catch(err => {
          console.log(err)
          if (err.data.resCode === '0001') {
            this.showRegisterDialog = true;
          }
        })
      } else {
        this.getOpenid()
      }
    },

    getOpenid() {
      let code = ''
      let href = location.href
      let isDevement = process.env.NODE_ENV === 'development'
      let appid = isDevement ? 'wx022d0e93def8ffa1' : 'wx5474aa13a019f4f4'
      // let secret = 'bf5fb5a78d4c850a8394043824a985c3'
      let secret = '035d7ee8f9939d6913906ea9012281cf'
      code = this.getUrlCode().code
      if (!code) {
        location.href = 
        `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(href)}&response_type=code&scope=snsapi_userinfo&state=jmx#wechat_redirect`
      } else {
        // 获取到code后，请求后端接口,获取openid，完成微信登录
        if (!isDevement) {
          reqWxToken({code: code}).then(res => {
            console.log(JSON.parse(res))
            let result = JSON.parse(res)
            localStorage.setItem('openid', result.openid)
            this.$store.state.access_token = result.access_token
            this.$store.state.refresh_token = result.refresh_token
            // this.getUserInfo()
          })
        } else {
          reqWxTest({
            appid,
            secret,
            code: code,
            grant_type: 'authorization_code'
          }).then(res => {
            localStorage.setItem('openid', res.openid)
            this.$store.state.access_token = res.access_token
            this.$store.state.refresh_token = res.refresh_token
            this.getUserInfo()
          })
        }
      }
    },

    getUserInfo() {
      //生产环境跨域了，后期需要获取再增加接口
      reqWxUserInfo({
        access_token: this.$store.state.access_token,
        openid: localStorage.openid,
        lang: 'zh_CN'
      }).then(res => {
        console.log("---getUserInfo:"+JSON.stringify(res))
        this.$store.state.wxUserInfo.nickname = res.nickname
        this.$store.state.wxUserInfo.headimgurl = res.headimgurl
      })
    },

    getUrlCode() {
      var url = location.search
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
          var str = url.substr(1)
          var strs = str.split("&")
          for(var i = 0; i < strs.length; i ++) {
              theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
          }
      }
      return theRequest
    },

    readProtol(type) {
      this.$router.push(`/protol?type=${type}`)
    },

    agreeProtol() {
      this.showProtol = false;
      this.agree = true;
    },

    good() {
      this.showBindSucces = false;
      this.$router.push('/')
    },

    refuse() {
      this.showRegisterDialog = false;
      this.reqData.phoneNo = '';
    },

    navigatePageTo() {
      this.showRegisterDialog = false;
      this.$router.replace("/register")
    }

  },
}

</script>

<style lang='less' scoped>
.btn-wrap {
  padding: 47px 0 40px;
}
.register {
  text-align: center;
}
.orange-text {
  color: #E3C194;
}
.register-dialog {
  width:331px;
  box-sizing: border-box;
  background:rgba(255,255,255,1);
  border-radius:15px;
  padding: 23px 32px;
  h3 {
    font-size: 17px;
    font-weight: bold;
    text-align: center;
  }
  .content {
    font-size: 14px;
    line-height: 28px;
    padding: 10px 0 20px;
    span {
      color: #238DF8;
    }
  }
  .register-btn {
    input {
      width: 125px;
      line-height: 36px;
    }
  }
}
</style>